import { Download, Monitor, Server } from 'lucide-react'

import { ButtonLink, Card, Icon } from 'ui'

export const installerDownloads = {
  linuxDeb: 'https://www.expandrive.com/api/download/expandrive_server?platform=linux&ext=deb',
  linuxRpm: 'https://www.expandrive.com/api/download/expandrive_server?platform=linux&ext=rpm',
  windows32: 'https://www.expandrive.com/api/download/expandrive_server?platform=win32',
  windows64: 'https://www.expandrive.com/api/download/expandrive_server?platform=win64',
}

const DownloadCard = ({ alternate, description, icon, primary, title }) => (
  <Card className="tw:flex tw:min-h-52 tw:flex-col tw:overflow-hidden">
    <div className="tw:flex tw:flex-1 tw:flex-col tw:p-5 tw:mobile:p-4">
      <div className="tw:flex tw:items-center tw:gap-2">
        <span className="tw:flex tw:h-9 tw:w-9 tw:items-center tw:justify-center tw:rounded-xs tw:bg-surface-subtle tw:text-foreground-strong">
          <Icon as={icon} />
        </span>
        <h3 className="ds-heading-4">{title}</h3>
      </div>
      <p className="ds-helper tw:mt-3 tw:max-w-[48ch]">{description}</p>
      <ButtonLink
        className="tw:mt-4 tw:self-start"
        href={primary.href}
        icon={<Icon as={Download} />}
        variant="cta"
      >
        {primary.label}
      </ButtonLink>
    </div>
    <div className="tw:flex tw:items-center tw:justify-between tw:gap-4 tw:border-t tw:border-default tw:bg-surface-muted tw:px-5 tw:py-4 tw:mobile:px-4">
      <div>
        <div className="tw:text-sm tw:font-semibold tw:text-foreground-strong">Other Format</div>
        <div className="ds-helper tw:mt-1">{alternate.description}</div>
      </div>
      <ButtonLink
        className="tw:shrink-0"
        href={alternate.href}
        icon={<Icon as={Download} />}
        size="sm"
        variant="ghost"
      >
        {alternate.label}
      </ButtonLink>
    </div>
  </Card>
)

export const InstallerDownloadCards = ({ className = '' }) => (
  <div className={`tw:grid tw:grid-cols-2 tw:gap-6 tw:mobile:grid-cols-1 ${className}`}>
    <DownloadCard
      alternate={{
        description: 'Legacy 32-bit systems',
        href: installerDownloads.windows32,
        label: 'Windows 32-bit',
      }}
      description="Installers for modern 64-bit hosts and legacy 32-bit systems."
      icon={Monitor}
      primary={{
        href: installerDownloads.windows64,
        label: 'Download Windows 64-bit',
      }}
      title="Windows Server"
    />
    <DownloadCard
      alternate={{
        description: 'RHEL, Fedora, and CentOS',
        href: installerDownloads.linuxRpm,
        label: 'Linux .rpm',
      }}
      description="64-bit Linux on x86-64, with .deb and .rpm packages."
      icon={Server}
      primary={{
        href: installerDownloads.linuxDeb,
        label: 'Download Linux .deb',
      }}
      title="Linux Servers"
    />
  </div>
)

export default InstallerDownloadCards
